const Listing = () => import('../../components/Tenant/Tenant/List')
const Manage = () => import('../../components/Tenant/Tenant/Manage')

export default {
    path: 'tenants',
    redirect: 'tenants',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'tenants',
    meta: {'permissions': 'view-tenants'},
    children: [
        {
            path: '/',
            component: Listing,
        },
        {
            path: 'create',
            name: 'create-tenant',
            meta: {'permissions': 'update-tenants-step1'},
            component: Manage,
        },
        {
            path: 'update/:id',
            name: 'update-tenant',
            component: Manage,
        },
    ],
};
